// @ts-ignore - this WAS working... dont want to break it... tor - 05/13/2019
import { Link as RouterLink } from 'react-router';
import createChainedFunction from 'utils/createChainedFunction';
import * as React from 'react';
import { MouseEventHandler, DragEventHandler } from '../types/typescript/eventHandlers';

/**
 * ## Unstyled link, rendering a [hyperlink](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a) or composing [React Router Link](https://github.com/ReactTraining/react-router/blob/5e69b23a369b7dbcb9afc6cdca9bf2dcf07ad432/docs/API.md#link).
 * ### Use [Link](/internal/components/Link) unless styling is not desirable.
 *
 * ```example
 * <LinkBase href="https://www.remind.com">
 *   LinkBase
 * </LinkBase>
 * ```
 *
 * ```example
 * <LinkBase to="/classes/">
 *   React Router LinkBase
 * </LinkBase>
 * ```
 */

export type Props = {
  /** Native */
  disabled?: boolean;
  download?: boolean;
  href?: string;
  target?: string;

  /** Active only when route is identical (`to`-only, React Router) */
  onlyActiveOnIndex?: boolean;
  rel?: string;
  /** Location descriptor (React Router) */
  to?: string | Object;

  'data-test-selector'?: string;
  activeClassName?: string;
  className?: string;
  onClick?: MouseEventHandler;
  onMouseEnter?: MouseEventHandler;
  onMouseLeave?: MouseEventHandler;
  onMouseMove?: MouseEventHandler;
  onDragEnd?: DragEventHandler;
};

class LinkBase extends React.Component<Props> {
  static defaultProps = {
    disabled: false,
    download: false,
  };

  handleClick = (event: React.MouseEvent<any, MouseEvent>) => {
    const { href, to, onClick } = this.props;

    if (onClick !== undefined) {
      onClick(event);
    }

    if ((!to && !href) || href === '#') {
      event.preventDefault();
    }
  };

  render() {
    const {
      children,
      className,
      disabled,
      download,
      href,
      onlyActiveOnIndex,
      rel,
      target,
      to,
      activeClassName,
      onDragEnd,
      onMouseEnter,
      onMouseLeave,
      onMouseMove,
    } = this.props;
    let link;

    if (to) {
      link = (
        <RouterLink
          disabled={disabled}
          onlyActiveOnIndex={onlyActiveOnIndex}
          target={target}
          to={to}
          className={className}
          activeClassName={activeClassName}
          onClick={this.handleClick}
          onDragEnd={onDragEnd}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onMouseMove={onMouseMove}
          data-test-selector={this.props['data-test-selector']}>
          {children}
        </RouterLink>
      );
    } else {
      const disabledProp = disabled ? { disabled: true } : {};
      link = (
        <a
          {...disabledProp}
          download={download}
          href={typeof href === 'undefined' ? '#' : href}
          rel={rel}
          target={target}
          className={className}
          onClick={this.handleClick}
          onDragEnd={onDragEnd}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onMouseMove={onMouseMove}
          data-test-selector={this.props['data-test-selector']}>
          {children}
        </a>
      );
    }

    return link;
  }
}

export default LinkBase;
